import PropTypes from 'prop-types';
import React from 'react';
import styles from './ErrorDialog.scss';
import Dialog from "components/common/material/Dialog";
import RaisedButton from "components/common/material/RaisedButton";
import CSSModules from "react-css-modules";
import {FormattedMessage} from "react-intl";
import {PHONE_NUMBER} from "../../../constants/sunbit";


const dialogTheme = {
  dialog: styles.dialogTheme
};

@CSSModules(styles, {allowMultiple: true})
class ErrorDialog extends React.Component{

  constructor(props) {
    super(props);
  }

  render(){
   return ( <Dialog theme={dialogTheme} active={this.props.isOpen}>
      <div styleName="dialogContent" data-at="dialog-content">
        <div data-at="payment-failed-dialog-close" styleName="closeIcon" onClick={this.props.onClose}>&nbsp;</div>
        <span data-at="dialog-text">
            <FormattedMessage
              id={this.props.paymentErrorMessageKey}
              values={{ phoneNumber: PHONE_NUMBER }}
            />
          </span>
        <RaisedButton data-at="payment-failed-close-btn" onClick={this.props.onClose.bind(this)}>
          CLOSE
        </RaisedButton>
      </div>
     </Dialog>
        ) ;

    }
}

ErrorDialog.propTypes = {
 onClose: PropTypes.func,
  isOpen: PropTypes.bool,
  paymentErrorMessageKey : PropTypes.string,
};

export default ErrorDialog;



// WEBPACK FOOTER //
// ./src/card/CardDialogs/ErrorDialog/ErrorDialog.js